const refreshState = {
    isRefreshing: false,
    isUnAuthorized: false,
    reIssueFailed: false,
};

export default refreshState;
